<div class="p-0 -mx-4 relative">
  @if (showHeader) {
  <div class="flex justify-between items-center mb-3">
    <h1 class="text-xl font-bold text-gray-800" data-testid="list-title">{{ title }}</h1>
    @if (addButtonLink) {
    <a [routerLink]="addButtonLink"
      class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-1.5 px-3 rounded-md text-sm transition-colors">
      Create
    </a>
    }
  </div>
  }


  @if (hasAnyNotification()) {
  <div data-testid="change-banner" class="absolute -top-[4.1em] -right-1 w-1/2 mb-1 bg-blue-50 border border-blue-200 rounded-lg p-1 flex items-center justify-between shadow-sm">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-3">
        <span class="relative group inline-flex items-center justify-center w-8 h-8 rounded-full bg-gray-200 text-gray-600">
          <i class="fas fa-bell-slash"></i>

          <span class="absolute left-1/2 -translate-x-1/2 -top-[2.2em]
                 bg-black text-white text-xs px-2 py-1 rounded shadow-md whitespace-nowrap
                 opacity-0 group-hover:opacity-100 transition pointer-events-none">
            {{ 'new-changes' | translate }}
          </span>
        </span>
      </div>

      <ul class="mt-0 pl-2 text-sm text-gray-600">
        @if (notificationSummary().added > 0) {
        <li> {{ notificationSummary().added }} {{ 'creations' | translate }}</li>
        }

        @if (notificationSummary().modified > 0) {
        <li> {{ notificationSummary().modified }} {{ 'modifications' | translate }}</li>
        }

        @if (notificationSummary().deleted > 0) {
        <li> {{ notificationSummary().deleted }} {{ 'suppressions' | translate }}</li>
        }
      </ul>

      <button (click)="dismissAllNotifications()"
        class="w-8 h-10 absolute right-0 bg-blue-300 hover:bg-blue-500 text-white text-sm rounded-l-full rounded-r-md transition-colors group">
        <i class="fa-solid fa-broom"></i>
        <span class="absolute left-1/2 -translate-x-1/2 -top-[2.2em]
            bg-black text-white text-xs px-2 py-1 rounded shadow-md whitespace-nowrap
            opacity-0 group-hover:opacity-100 transition pointer-events-none">
          {{ 'clear-all' | translate }}
        </span>
      </button>
    </div>


  </div>
  }

  <div class="flex gap-1 items-center">

    @if (showSearchBar) {
    <app-search-bar class="px-6 "
      [(searchTerm)]="searchTerm"
      (searchTermChange)="refresh()"
      (search)="onSearch($event)"
      [searchState]="searchState()"></app-search-bar>

    }


    @if (ShowRangeDateFilter ) {
    <div class="date-range-filter-container flex items-center -mt-3">
      <app-date-range-picker [startDate]="selectedStartDate" [endDate]="selectedEndDate"
        (dateRangeChange)="onPickerRangeChange($event)"></app-date-range-picker>
      <app-date-range-select [preset]="dateSelected()?.preset ?? 'Today'"
        (dateRangeChange)="onDateRangeChange($event)"></app-date-range-select>

    </div>
    }
    <!-- Section de filtres personnalisés -->
    <div class="custom-filters-section mb-3">
      <ng-content select="[slot=custom-filters]"></ng-content>
    </div>
  </div>

  @if (entities().truncated) {
  <div class="flex items-center gap-2 mb-2 px-3 py-1.5 text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-md"
    data-testid="list-truncated">
    <i class="fa-solid fa-circle-info"></i>
    <span class="font-medium">{{ entities().loadedCount }} / {{ entities().total }}</span>
  </div>
  }

  <div class="rounded-b-md relative">


    <!-- Composant Table avec gestion des événements -->
    <div class="overflow-x-auto">
      @if (listType === IListType.Table) {
      <app-table [entities]="entities().items"
        [columns]="columns()"
        [fuseauxParSite]="fuseauxParSite"
        [sortableColumns]="resolvedSortableColumns"
        [sortBy]="sortBy()"
        [sortOrder]="sortOrder()"
        [selectedId]="selectedId()"
        [contextMenuItems]="contextMenuItems"
        [showActions]="showActions"
        [canEdit]="canEdit"
        [showEntityState]="showEntityState"
        (sortChange)="onTableSortChange($event)"
        (entitySelected)="onTableEntitySelected($event)"
        (contextMenuAction)="onTableContextMenuAction($event)"
        (editAction)="onEditAction($event)"
        (deleteAction)="onDeleteAction($event)"
        [dismissEntity]="dismissEntity"
        [tooltipTemplate]="entityStateTooltip"
        [dismissEntity]="onRowDismiss">
      </app-table>
      } @else if (listType === IListType.Stack) {
      <app-list-stack [items]="entities().items"
        [columns]="columns()"
        [fuseauxParSite]="fuseauxParSite"
        [selectedId]="selectedId()"
        (itemSelected)="onTableEntitySelected($event)">
      </app-list-stack>
      }
    </div>


    @if (pagination.enabled) {
    @if (paginatorType === 'dropdown') {
    <app-paginator [(page)]="page"
      [(pageSize)]="pageSize"
      [total]="entities().total"
      [totalItems]="entities().items.length"
      [pageLengths]="pagination.pageLengths"
      (pageChange)="refresh()"
      (pageSizeChange)="refresh()"></app-paginator>
    } @else {
    <app-button-paginator [(page)]="page"
      [(pageSize)]="pageSize"
      [total]="entities().total"
      [totalItems]="entities().items.length"
      (pageChange)="refresh()"
      (pageSizeChange)="refresh()">
    </app-button-paginator>
    }
    }
  </div>

  @if (showCreateButton) {
  <hr />

  <!--'Create' button on all lists-->

  <div class="flex justify-start mt-6 gap-2">
    <button (click)="onCreateButtonClick()" data-testid="list-create" [disabled]="createDisabled"
      class="bg-teal-500 hover:bg-teal-600 text-white px-4 py-2 text-sm font-medium border border-gray-200 focus:outline-none disabled:bg-gray-300 disabled:cursor-not-allowed disabled:hover:bg-gray-300">
      {{ `buttons.create` | translate }}
    </button>
    <ng-content select="[slot=list-actions]"></ng-content>
  </div>
  }
</div>


<!-- Template du tooltip avec structure 3 zones -->
<ng-template #entityStateTooltip let-ctx>
  <div class="bg-white rounded-xl shadow-2xl relative border border-gray-100 min-w-[280px] max-w-[400px] overflow-hidden">

    <!-- ZONE 1 : TITRE / HEADER -->
    <div class="flex items-center gap-3 pl-5 py-1 border-b border-gray-100 bg-slate-300"
      [class]="'bg-' + ctx.stateColor + '-50'">

      <span class="text-xl text-slate-600">
        {{ ctx.stateIcon }}
      </span>

      <h3 class="font-bold text-lg" [class]="'text-' + ctx.stateColor + '-800'">
        {{ ctx.stateLabel | translate }}
      </h3>
    </div>

    <!-- ZONE 2 : CORPS / DÉTAILS -->
    <div class="p-4 space-y-3">

      <!-- Cas Modification : Liste des champs modifiés -->
      @if (ctx.state === 3 && ctx.modifiedProperties.length > 0) {
      <div>
        <h4 class="text-xs font-bold text-gray-500 tracking-wider mb-2">
          {{ 'modified-fields' | translate }}
        </h4>
        <ul class="space-y-1">
          @for (prop of ctx.modifiedProperties; track prop) {
          <li class="flex items-center gap-2 text-sm text-gray-700">
            <span class="w-1.5 h-1.5 rounded-full bg-amber-400"> </span>
            {{ 'entities.'+ (metaData.EntityName[0].toLowerCase() + metaData.EntityName.slice(1)) +'.propreties.' + (prop[0].toLowerCase() + prop.slice(1)) | translate }}
          </li>
          }
        </ul>
      </div>
      }

      <!-- Cas Ajout : Message informatif -->
      @if (ctx.state === 4) {
      <p class="text-sm text-gray-600">
        {{ 'Created' | translate }}
      </p>
      }

      <!-- Cas Suppression : Message d'avertissement -->
      @if (ctx.state === 2) {
      <p class="text-sm text-red-600">
        {{ 'Deleted' | translate }}
      </p>
      }

      <!-- Informations complémentaires (heure, auteur) — masqué si données absentes -->
      @if (ctx.entity._modifiedAt || ctx.entity._modifiedBy) {
      <div class="absolute p-1 border-t border-gray-100">
        @if (ctx.entity._modifiedAt) {
        <div class="flex items-center gap-2 text-[9px] text-gray-500">
          <svg class="w-4 h-4 text-red-600 font-bold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <span> {{ ctx.entity._modifiedAt | date:'short' }}</span>
        </div>
        }
        @if (ctx.entity._modifiedBy) {
        <div class="flex items-center gap-2 text-[9px] text-gray-500 m-0 max-w-[80%]">
          <svg class="w-4 h-4 text-red-600 font-bold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
          </svg>
          <span> {{ ctx.entity._modifiedBy }}</span>
        </div>
        }
      </div>
      }
    </div>

    <!-- ZONE 3 : ACTIONS / FOOTER -->
    <div class="py-[10px] px-4 bg-slate-300 border-t border-gray-100 flex justify-end">
      <button (click)="ctx.dismiss()"
        class="px-4 py-1 bg-blue-500 border border-gray-300 rounded-lg text-sm font-medium
                   text-gray-100 hover:bg-blue-700 hover:border-gray-400 transition-colors
                   focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
        {{ 'thank-you' | translate }}
      </button>
    </div>

    <!-- Flèche -->
    <div class="absolute w-3 h-3  bg-white rotate-45 border-gray-200
                    top-[50%] -left-[5px] border-l border-b"></div>
  </div>
</ng-template>